import { useState, useEffect } from 'react';

const ThemeToggle = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // Cek preferensi user dari localStorage atau system preference
    const isDark =
      localStorage.getItem('darkMode') === 'true' ||
      (!('darkMode' in localStorage) &&
        window.matchMedia('(prefers-color-scheme: dark)').matches);

    setDarkMode(isDark);
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('darkMode', newMode);
    if (newMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <button
      onClick={toggleDarkMode}
      className="relative w-11 h-6 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-accent/50 dark:focus:ring-dark-accent/50 border border-border dark:border-dark-border bg-surface-secondary dark:bg-dark-surface-secondary"
      role="switch"
      aria-checked={darkMode}
      aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Sliding knob */}
      <span
        className={`absolute top-0.5 w-5 h-5 rounded-full bg-white dark:bg-dark-text-primary shadow-sm transition-all duration-300 transform ${
          darkMode ? 'translate-x-[22px]' : 'translate-x-0.5'
        } flex items-center justify-center`}
      >
        {darkMode ? (
          <svg className="w-3 h-3 text-background dark:text-dark-bg" fill="currentColor" viewBox="0 0 24 24">
            <path d="M21.53 15.93a.75.75 0 0 1-.9.6A9.75 9.75 0 0 1 12 3.75a.75.75 0 0 0-.88-1.21 9 9 0 1 0 10.18 13.39.75.75 0 0 0 .23 0zm-2.17 1.62a7.5 7.5 0 1 1-10.55-9.55 8.25 8.25 0 0 0 10.55 9.55z" />
          </svg>
        ) : (
          <svg className="w-3 h-3 text-accent dark:text-dark-accent" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;